import { jsx as _jsx } from "react/jsx-runtime";
import TutorPage from "./TutorPage";
export default function SubtractionPage() {
    return _jsx(TutorPage, { initialTopic: "Subtraction", lockTopic: true });
}
